import showToastr from './showToastr';


function showSystemError () {
  showToastr('fa fa-exclamation-circle','There has been a system error. Please reload the page.')
}

export default showSystemError;